"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = DatePicker;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
require("moment/min/locales");
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _xDatePickers = require("@mui/x-date-pickers");
var _AdapterMoment = require("@mui/x-date-pickers/AdapterMoment");
var _Icon = _interopRequireDefault(require("../Icon/Icon"));
require("./styles.scss");
function DatePicker(props) {
  var _props$locale, _props$defaultTimeZon;
  var _useState = (0, _react.useState)(props.value || null),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    temporalValue = _useState2[0],
    setTemporalValue = _useState2[1];
  var locale = (_props$locale = props.locale) !== null && _props$locale !== void 0 ? _props$locale : 'en';
  _react.default.useEffect(function () {
    _momentTimezone.default.locale([locale]);
  }, [locale]);
  _react.default.useEffect(function () {
    if (props.value !== temporalValue && props.value !== null) {
      setTemporalValue(props.value || null);
    }
  }, [props.value]);
  var renderInput = function renderInput(params) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.TextField, Object.assign({}, params, {
      id: props.id,
      autoFocus: props.autoFocus,
      onKeyPress: props.onKeyPress
    })), props.errorText && /*#__PURE__*/_react.default.createElement("div", {
      className: "textfield-error-text-container"
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      name: "error",
      className: "textfield-error-text--icon"
    }), /*#__PURE__*/_react.default.createElement("label", {
      htmlFor: props.id,
      className: "textfield-error-text"
    }, props.errorText)));
  };

  // set timezone, defaulting to 'UTC'
  _momentTimezone.default.tz.setDefault((_props$defaultTimeZon = props.defaultTimeZone) !== null && _props$defaultTimeZon !== void 0 ? _props$defaultTimeZon : 'UTC');

  // TODO: Localize the yyyy-mm-dd placeholder string that is shown to users when the input is
  //       empty. It appears to be generated programmatically deep in the guts of the MUI DatePicker
  //       code, and it most likely uses the browser's locale.
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "date-picker ".concat(props.className, " ").concat(props.errorText ? 'date-picker--error' : '')
  }, /*#__PURE__*/_react.default.createElement(_xDatePickers.LocalizationProvider, {
    dateAdapter: _AdapterMoment.AdapterMoment,
    dateLibInstance: _momentTimezone.default,
    adapterLocale: locale
  }, props.label && /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: props.id,
    className: "textfield-label"
  }, props.label), /*#__PURE__*/_react.default.createElement(_xDatePickers.DesktopDatePicker, {
    onError: props.onError,
    minDate: props.minDate ? (0, _momentTimezone.default)(props.minDate) : undefined,
    maxDate: props.maxDate ? (0, _momentTimezone.default)(props.maxDate) : undefined,
    inputFormat: "YYYY-MM-DD",
    value: temporalValue,
    onChange: function onChange(newValue) {
      setTemporalValue(newValue);
      props.onChange(newValue !== null && newValue !== void 0 && newValue.isValid() ? newValue === null || newValue === void 0 ? void 0 : newValue.toDate() : null);
    },
    renderInput: renderInput,
    disabled: props.disabled
  })));
}